import React from "react";
import { Link } from "react-router-dom";
import { LandPlot, Handshake, Building2, ShieldCheck, Box, Users, ChevronRight } from "lucide-react";
import PublicLayout from "../components/PublicLayout";
import { useI18n } from "../i18n/I18nContext";
import { useSite } from "../context/SiteContext";

const ICONS = { LandPlot, Handshake, Building2, ShieldCheck, Box, Users };

export default function Services() {
    const { t, lang } = useI18n();
    const { site } = useSite();
    const items = site?.services || [];
    const cta = site?.cta_band || {};
    const ctaText = lang === "en" ? cta.text_en : cta.text_fr;
    const ctaButton = lang === "en" ? cta.button_en : cta.button_fr;
    return (
        <PublicLayout>
            <section className="bg-brand-navy text-white" data-testid="services-hero">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
                    <div className="text-[0.7rem] tracking-[0.3em] uppercase font-semibold text-brand-gold mb-3">{t("nav.services")}</div>
                    <h1 className="font-display text-5xl sm:text-6xl leading-tight">{t("services.title")}</h1>
                    <p className="mt-5 text-white/75 max-w-2xl">{t("services.subtitle")}</p>
                </div>
            </section>
            <section className="py-20 bg-brand-paper">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-6">
                    {items.map((s, idx) => {
                        const Icon = ICONS[s.icon] || Users;
                        const title = lang === "en" ? s.title_en || s.title_fr : s.title_fr;
                        const text = lang === "en" ? s.text_en || s.text_fr : s.text_fr;
                        return (
                            <div key={s.key || idx} className="group bg-white p-8 lg:p-10 border border-gray-100 hover:border-brand-gold/40 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_12px_40px_rgb(0,0,0,0.08)] transition-all flex gap-6" data-testid={`services-item-${s.key || idx}`}>
                                <div className="w-14 h-14 bg-brand-emerald/10 flex items-center justify-center flex-shrink-0 group-hover:bg-brand-emerald transition-colors">
                                    <Icon className="w-6 h-6 text-brand-emerald group-hover:text-white" strokeWidth={1.5} />
                                </div>
                                <div>
                                    <div className="text-xs tracking-[0.2em] uppercase font-bold text-brand-gold mb-2">0{idx + 1}</div>
                                    <h3 className="font-display text-2xl text-brand-navy mb-3">{title}</h3>
                                    <p className="text-gray-600 leading-relaxed">{text}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </section>
            <section className="bg-brand-gold text-brand-navy">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 flex flex-col sm:flex-row items-center justify-between gap-5">
                    <p className="font-display text-2xl sm:text-3xl">{ctaText || t("cta_band.text")}</p>
                    <Link to="/contact" className="inline-flex items-center px-8 py-4 bg-brand-navy text-white hover:bg-white hover:text-brand-navy text-[0.72rem] tracking-[0.24em] uppercase font-semibold transition-colors" data-testid="services-cta">
                        {ctaButton || t("cta_band.button")} <ChevronRight className="w-4 h-4 ml-2" />
                    </Link>
                </div>
            </section>
        </PublicLayout>
    );
}
